import "../css/App.css";
import { BrowserRouter, Route } from "react-router-dom";
import Home from "./Home";
import NavbarJS from "./NavbarJS";
import Work from "./Work";
import AboutMe from "./AboutMe";
import Footer from "./Footer";
// import Resume from "./Resume";

function App() {
  return (
    <div className="App">
      <div style={{ height: "100vh" }}>
        <BrowserRouter>
          <NavbarJS />
          <div>
            <Route path="/" exact component={Home} />
            <Route path="/Work" exact component={Work} />
          </div>
        </BrowserRouter>
      </div>
      <AboutMe />
      <Footer />
      {/* <Route path="/Resume" exact component={Resume} /> */}

    </div>
  );
}

export default App;
